module.exports = __webpack_public_path__ + "static/img/newsDetailPic1.fdeb5bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic1.png
// module id = Kwqo
// module chunks = 1